"use strict";

function btyInViewport(e) {
    if (!e) return;
    let t = e.getBoundingClientRect();
    return t.top >= 0 && t.left >= 0 && t.bottom <= (window.innerHeight || document.documentElement.clientHeight) && t.right <= (window.innerWidth || document.documentElement.clientWidth)
}
let lastFocusedFilterElement = null,
    filterUpdateInProgress = !1;

function btyToggleNavList(e = document) {
    let t = e.querySelectorAll(".link-arrow");
    t.length && "function" == typeof btySlideUp && "function" == typeof btySlideDown && t.forEach((function(e) {
        e.onclick = function(t) {
            t.preventDefault();
            let n = e.parentNode.parentNode,
                i = n.querySelector(".link-sub");
            if (i) {
                n.classList.contains("active") ? (btySlideUp(i), n.classList.remove("active")) : (btySlideDown(i), n.classList.add("active"));
                for (let e = 0, t = n.parentNode.children.length; e < t; e++) {
                    let t = n.parentNode.children[e];
                    if (!t.classList.contains("active") || n === t || t.nodeName !== n.nodeName) continue;
                    t.classList.remove("active");
                    let i = t.querySelector(".link-sub");
                    i && btySlideUp(i)
                }
            }
        }
    }))
}

function btyRangeSlider(e = document) {
    let t = e.querySelectorAll(".price-slider");
    t.length && void 0 !== window.noUiSlider && t.forEach((function(e) {
        let t = e.querySelector("template");
        if (!t || "function" != typeof btyJsonParse || "object" == typeof e.noUiSlider) return;
        let n = btyJsonParse(t.content.textContent),
            i = e.parentNode.querySelectorAll(".price-value");
        n.format = {
            from: e => n.range.min == e ? e : Math.round(e),
            to: e => n.range.max == e ? e : Math.round(e)
        }, window.btyRangePrice = noUiSlider.create(e, n);
        const r = e.querySelectorAll(".noUi-handle");
        r.forEach(((e, t) => {
            e.setAttribute("tabindex", "0"), e.dataset.handleIndex = String(t), e.setAttribute("role", "slider"), e.getAttribute("aria-label") || e.setAttribute("aria-label", 0 === t ? "Minimum price" : "Maximum price"), e.addEventListener("focus", (() => {
                lastFocusedFilterElement = {
                    type: "slider-handle",
                    handleIndex: t
                }
            })), e.addEventListener("keydown", (e => {
                "Tab" === e.key && (!e.shiftKey && 0 === t && r[1] ? (e.preventDefault(), r[1].focus()) : e.shiftKey && 1 === t && r[0] && (e.preventDefault(), r[0].focus()))
            }))
        })), t.remove();
        let o = 0,
            l = 0;
        btyRangePrice.on("slide", (function(t) {
            i.length && i.forEach((function(e) {
                let n = e.getAttribute("data-type");
                "min" === n ? (e.value = t[0], o = Number(t[0])) : "max" === n && (e.value = t[1], l = Number(t[1]))
            }));
            e.querySelectorAll(".noUi-handle").forEach((function(e, n) {
                e.setAttribute("aria-valuenow", t[n])
            }))
        })), btyRangePrice.on("update", (function(t) {
            e.querySelectorAll(".noUi-handle").forEach((function(e, n) {
                e.setAttribute("aria-valuenow", t[n])
            }))
        })), btyRangePrice.on("change", (function() {
            if (i.length) {
                const e = document.activeElement;
                e && e.classList.contains("price-value") && (lastFocusedFilterElement = {
                    type: "price-input",
                    dataType: e.getAttribute("data-type"),
                    id: e.id
                });
                let t = new Event("change", {
                    bubbles: !0
                });
                i[0].dispatchEvent(t)
            }
        })), i.length && i.forEach((function(e) {
            let t, n = e.getAttribute("data-type"),
                r = Number(e.value || 0);

            function a(e) {
                let t = Number(e.getAttribute("min") || 0),
                    n = Number(e.getAttribute("max") || 0),
                    r = Number(e.value || 0);
                r < t && (e.value = t), r > n && (e.value = n), r = Number(e.value || 0), "min" === e.getAttribute("data-type") ? o = r : "max" === e.getAttribute("data-type") && (l = r);
                const a = "" === i[0].value || isNaN(Number(i[0].value)),
                    c = "" === i[1].value || isNaN(Number(i[1].value));
                if (!a && !c) {
                    if (o > l) {
                        const e = o;
                        o = l, l = e, i.forEach((e => {
                            "min" === e.getAttribute("data-type") && (e.value = o), "max" === e.getAttribute("data-type") && (e.value = l)
                        }))
                    }
                    o < l && btyRangePrice.set([o, l]), e.removeAttribute("aria-invalid")
                }
            }
            "min" === n ? o = r : "max" === n && (l = r), e.addEventListener("focus", (function() {
                lastFocusedFilterElement = {
                    type: "price-input",
                    dataType: this.getAttribute("data-type"),
                    id: this.id
                }
            })), e.addEventListener("keydown", (function(e) {
                "Enter" === e.key && (e.preventDefault(), lastFocusedFilterElement = {
                    type: "price-input",
                    dataType: this.getAttribute("data-type"),
                    id: this.id
                }, a(this), this.dispatchEvent(new Event("change", {
                    bubbles: !0
                })), this.blur())
            })), e.addEventListener("blur", (function() {
                a(this)
            })), e.addEventListener("input", (function() {
                clearTimeout(t), t = setTimeout((() => {
                    let t = Number(e.value || 0),
                        n = Number(e.getAttribute("min") || 0),
                        i = Number(e.getAttribute("max") || 0);
                    t < n || t > i ? e.setAttribute("aria-invalid", "true") : e.removeAttribute("aria-invalid")
                }), 500)
            }))
        }))
    }))
}

function restoreFocusAfterFilterUpdate(e) {
    lastFocusedFilterElement && setTimeout((function() {
        let t = null;
        if ("slider-handle" === lastFocusedFilterElement.type) {
            const n = e.querySelector(".price-slider");
            if (n) {
                if (lastFocusedFilterElement.handleClass && (t = n.querySelector("." + lastFocusedFilterElement.handleClass)), t || void 0 === lastFocusedFilterElement.handleIndex || (t = n.querySelector('[data-handle-index="' + lastFocusedFilterElement.handleIndex + '"]')), !t) {
                    const e = n.querySelectorAll(".noUi-handle");
                    e[lastFocusedFilterElement.handleIndex] && (t = e[lastFocusedFilterElement.handleIndex])
                }
                t || (t = 0 === lastFocusedFilterElement.handleIndex ? n.querySelector(".noUi-handle-lower") : n.querySelector(".noUi-handle-upper"))
            }
        } else "price-input" === lastFocusedFilterElement.type && (lastFocusedFilterElement.id && (t = e.querySelector("#" + lastFocusedFilterElement.id)), !t && lastFocusedFilterElement.dataType && (t = e.querySelector('.price-value[data-type="' + lastFocusedFilterElement.dataType + '"]')));
        if (t) t.focus(), announceFilterUpdate();
        else {
            const t = e.querySelector(".filter-item[data-index] .details-summary");
            t && (t.focus(), announceFilterUpdate())
        }
        filterUpdateInProgress = !1
    }), 200)
}

function refocusSliderHandleAfterReinit(e) {
    if (!lastFocusedFilterElement || "slider-handle" !== lastFocusedFilterElement.type) return;
    const t = setInterval((() => {
        const n = e.querySelector(".price-slider");
        if (!n || !n.noUiSlider) return;
        const i = n.querySelectorAll(".noUi-handle");
        if (!i.length) return;
        let r = i[lastFocusedFilterElement.handleIndex] || i[0];
        r && (r.focus(), r.dispatchEvent(new Event("focus", {
            bubbles: !0
        })), clearInterval(t))
    }), 150);
    setTimeout((() => clearInterval(t)), 2e3)
}

function announceFilterUpdate() {
    let e = document.getElementById("filter-status-announce");
    e || (e = document.createElement("div"), e.id = "filter-status-announce", e.className = "sr-only", e.setAttribute("role", "status"), e.setAttribute("aria-live", "polite"), e.setAttribute("aria-atomic", "true"), document.body.appendChild(e)), e.textContent = "Price filter applied. Products updated.", setTimeout((function() {
        e.textContent = ""
    }), 1e3)
}

function btyRemoveParam(e, t) {
    let n, i = t.split("?")[0],
        r = [],
        o = t.includes("?") ? t.split("?")[1] : "";
    if ("" !== o) {
        r = o.split("&");
        for (let t = r.length - 1; t >= 0; t -= 1) n = r[t].split("=")[0], n === e && r.splice(t, 1);
        r.length && (i = i + "?" + r.join("&"))
    }
    return i
}

function btyPagination(e, t) {
    let n = document.querySelectorAll(".pagination a");
    n.length && n.forEach((function(n) {
        n.onclick = function(i) {
            i.preventDefault();
            let r = n.getAttribute("data-page") || 2;
            t.searchParams.set("page", Number(r)), e(t)
        }
    }))
}

function btyMiniSearch(e = document) {
    let t = e.querySelector('[name="q"]');
    if (!t) return;
    let n = t.parentNode.querySelector(".mini-results");
    n && (t.oninput = function() {
        let e = t.value.trim();
        e ? btySearchDelay((function() {
            t.parentNode.classList.add("searching");
            let i = btyGlobals.search_url + "?section_id=mini-search&type=" + btyGlobals.search_type + "&options[prefix]=last&options[unavailable_products]=" + btyGlobals.search_unavailable + "&limit=4&q=" + e;
            fetch(i).then((function(e) {
                if (200 !== e.status) throw console.log("Status Code: " + e.status), e;
                return e.text()
            })).then((function(e) {
                n.innerHTML = btyGetSectionHtml(e, ".fetch-search")
            })).catch((function(e) {
                console.error(e)
            })).finally((function() {
                t.parentNode.classList.remove("searching")
            }))
        }), 300) : n.innerHTML = ""
    }, t.onfocus = function() {
        n.classList.remove("hidden")
    }, t.onblur = function() {
        setTimeout((function() {
            n.classList.add("hidden")
        }), 200)
    })
}

function btyToggleSidebar(e = document) {
    let t = e.querySelector(".show-filter input[type='checkbox']"),
        n = t?.closest(".layout-collection .action-layout");
    if (!t || !n) return;
    const i = t.closest(".show-filter");
    i && !i.hasAttribute("tabindex") && i.setAttribute("tabindex", "0");
    const r = () => {
        t.checked ? (n.classList.add("has-sidebar"), n.classList.remove("no-sidebar")) : (n.classList.remove("has-sidebar"), n.classList.add("no-sidebar")), t.setAttribute("aria-expanded", t.checked ? "true" : "false")
    };
    r(), t.addEventListener("change", r), i && i.addEventListener("keydown", (e => {
        document.activeElement !== t && (" " !== e.key && "Enter" !== e.key || (e.preventDefault(), t.click()))
    }))
}

function btyColumnChange(e = document) {
    let t = e.querySelector(".layer-last .products"),
        n = e.querySelectorAll(".change-column-product .item");
    if (!t || !n.length) return;
    const i = e => {
            e && (t.style.gridTemplateColumns = `repeat(${e}, minmax(0, 1fr))`)
        },
        r = e.querySelector(".change-column-product .item.active");
    r && i(r.getAttribute("data-column")), n.forEach((e => {
        e.onclick = () => (e => {
            const n = e.getAttribute("data-column");
            if (!n) return;
            const r = e.parentNode.querySelector(".item.active");
            r && r.classList.remove("active"), e.classList.add("active"), t.classList.add("is-switching"), setTimeout((() => {
                i(n), t.classList.remove("is-switching")
            }), 250)
        })(e)
    }))
}

function btyDesktopFilters(e = document) {
    let t = new URL(window.location.href),
        n = e.querySelector(".has-product-filters"),
        i = !!n && n.querySelector(".content");
    if (!i) return;
    let r = !!n && n.querySelector(".filter-form"),
        o = function() {
            let e = r ? r.querySelectorAll(".filter-item[data-motion-reduce]") : [];
            e.length && (e.forEach((function(e) {
                e.addEventListener("click", (function() {
                    let t = e.parentNode.querySelector(".filter-item[open]");
                    t && t !== e && t.removeAttribute("open")
                }))
            })), document.addEventListener("click", (function(e) {
                if (e.target.closest(".filter-item")) return;
                let t = r.querySelector(".filter-item[open]");
                t && t.removeAttribute("open")
            })))
        },
        l = function() {
            let e = n.querySelector('select[name="sort_by"]');
            e && (e.onchange = function() {
                e.value.trim() && (t = new URL(window.location.href), t.searchParams.set("sort_by", e.value), u(t, "sort_by"))
            })
        },
        a = function() {
            let e = r ? r.querySelectorAll('[name^="filter."]') : [];
            e.length && e.forEach((function(e) {
                e.onchange = function() {
                    let e = new FormData(r),
                        n = window.location.pathname + "?" + new URLSearchParams(e).toString();
                    t = new URL(n, window.location.origin), u(t, "filters")
                }
            }))
        },
        c = function() {
            let e = n.querySelectorAll(".active-filter .active-filter-item, .item-reset");
            e.length && e.forEach((function(e) {
                e.addEventListener("click", (function(e) {
                    e.preventDefault();
                    const t = new URL(window.location.pathname, window.location.origin);
                    u(t, "filters")
                }))
            }))
        },
        s = function(e) {
            let t = e.querySelectorAll(".item-list");
            t.length && t.forEach((function(e) {
                "" === e.innerHTML && e.parentNode.parentNode.remove()
            }))
        };
    btyMiniSearch(n);
    let u = function(e, t = !1) {
        let r = document.querySelector(".loading-bar");
        filterUpdateInProgress = !0, window.desktopFiltering = u, r && (r.classList.add("active"), r.style.transform = "scaleX(0.7)");
        let d = n.querySelector('[name="q"]');
        if (d && (e.searchParams.set("q", d.value.trim()), e.searchParams.set("type", btyGlobals.search_type), e.searchParams.set("options[prefix]", "last"), e.searchParams.set("options[unavailable_products]", btyGlobals.search_unavailable)), document.documentElement.setAttribute("data-filtering", ""), e) {
            let n = e.toString();
            i && i.classList.contains("infinite-scroll") && ["infinite-scroll", "filters", "sort_by"].includes(t) && (n = btyRemoveParam("page", n)), window.history.pushState({
                path: n
            }, "", n)
        }
        let f = e && e.search ? "&" + e.search.slice(1) : "",
            m = window.location.pathname + "?section_id=" + n.getAttribute("data-id") + f;
        fetch(m).then((function(e) {
            if (200 !== e.status) throw console.log("Status Code: " + e.status), e;
            return e.text()
        })).then((function(r) {
            let d = n.querySelector(".active-filter"),
                f = n.querySelector(".filter-form"),
                m = n.querySelectorAll(".results-count"),
                y = n.querySelector(".products"),
                b = n.querySelector(".pagination"),
                p = n.querySelector(".infinite-loading"),
                h = n.querySelector(".layer-last");
            if (i.classList.contains("infinite-scroll")) {
                if (d && (d.innerHTML = btyGetSectionHtml(r, ".active-filter")), m.length && m.forEach((function(e) {
                        e.innerHTML = btyGetSectionHtml(r, ".results-count"), i.classList.contains("infinite-scroll") && e.querySelector(".from-count") && (e.querySelector(".from-count").innerText = 1)
                    })), b && (b.innerHTML = btyGetSectionHtml(r, ".pagination")), "infinite-scroll" === t) {
                    let e = (new DOMParser).parseFromString(r, "text/html").querySelectorAll(".product-card");
                    e.length && e.forEach((function(e) {
                        e.classList.add("ready"), y && y.insertAdjacentHTML("beforeend", e.outerHTML)
                    }));
                    let t = function() {
                        let e = i.querySelectorAll(".product-card.ready");
                        if (!e.length) return;
                        const t = new IntersectionObserver((function(e, t) {
                            e.forEach((function(e) {
                                if (e.isIntersecting) {
                                    let n = e.target;
                                    if (n.classList.contains("animate")) return;
                                    n.classList.add("animate"), t.unobserve(n)
                                }
                            }))
                        }), {
                            rootMargin: "-20px 0px -20px 0px"
                        });
                        e.forEach((function(e) {
                            t.observe(e)
                        }))
                    };
                    if (t(), window.addEventListener("scroll", t), f) {
                        let e = document.createElement("div"),
                            t = f.querySelectorAll(".filter-item");
                        e.innerHTML = btyGetSectionHtml(r, ".filter-form", "outer"), t.length && t.forEach((function(t) {
                            let n = t.getAttribute("data-index") || 0,
                                i = e.querySelector('.filter-item[data-index="' + n + '"]');
                            i && "string" == typeof t.getAttribute("open") && i.setAttribute("open", "")
                        })), s(e), f.innerHTML = btyGetSectionHtml(e.innerHTML, ".filter-form")
                    }
                } else {
                    y && (y.innerHTML = btyGetSectionHtml(r, ".products"));
                    const e = btyGetSectionHtml(r, ".filter-wrapper"),
                        t = document.querySelector(".filter-wrapper");
                    t && e && (t.innerHTML = e), p && p.classList.remove("visible")
                }
                let e = btyGetSectionHtml(r, ".infinite-loading");
                p ? e ? (p.innerHTML = e, p.classList.remove("visible")) : p.remove() : y && e && y.insertAdjacentHTML("afterend", '<div class="infinite-loading">' + e + "</div>")
            } else {
                m?.forEach?.((e => {
                    e.innerHTML = btyGetSectionHtml(r, ".toolbar-inner .results-count")
                })), d && (d.innerHTML = btyGetSectionHtml(r, ".active-filter"));
                const e = document.createElement("div");
                e.innerHTML = btyGetSectionHtml(r, ".filter-wrapper");
                const t = document.querySelector(".filter-wrapper");
                t && t.querySelectorAll(".filter-item").forEach((t => {
                    if (t.matches('[data-type="price_range"]')) return;
                    const n = t.getAttribute("data-index");
                    let i = n ? e.querySelector(`.filter-item[data-index="${n}"]`) : null;
                    if (i) {
                        const e = t.hasAttribute("open"),
                            n = i.cloneNode(!0);
                        e && n.setAttribute("open", ""), t.replaceWith(n)
                    }
                })), h && (h.innerHTML = btyGetSectionHtml(r, ".layer-last"))
            }
            o(), a(), btyPagination(u, e), btyAnimationImageLoad(n), l(), c(), btyRangeSlider(n), btyDesktopFilters(document), btyToggleDetails(n), btyHoverMediaVideo(n), btyQuickView(n), btyQuickAdd(n), btySwatch(n), btyAccordionHandle(n), btyAddToCart(n), document.dispatchEvent(new CustomEvent("product-card-updated")), restoreFocusAfterFilterUpdate(n), refocusSliderHandleAfterReinit(n)
        })).catch((function(e) {
            console.error(e), filterUpdateInProgress = !1
        })).finally((function() {
            btyColumnChange(), btyToggleSidebar(), document.documentElement.removeAttribute("data-filtering"), "infinite-scroll" !== t && function() {
                let e = n.querySelector(".filter-form-wrapper");
                e && e.getBoundingClientRect().top < 0 && e.scrollIntoView({
                    behavior: "smooth"
                })
            }(), r && (r.style.transform = "scaleX(1)", r.setAttribute("data-finished", ""), r.addEventListener("transitionend", (function(e) {
                "transform" === e.propertyName && "string" == typeof r.getAttribute("data-finished") && (r.classList.remove("active"), r.removeAttribute("data-finished"), r.style.transform = "scaleX(0)")
            })))
        }))
    };
    btyRangeSlider(e);
    let d = function() {
        let e = !!i && i.querySelector(".infinite-loading");
        if (e && !e.classList.contains("visible") && btyInViewport(e)) {
            e.classList.add("visible");
            let n = e.querySelector("span[data-page]");
            if (!n) return;
            t = new URL(window.location.href), t.searchParams.set("page", Number(n.getAttribute("data-page"))), u(t, "infinite-scroll")
        }
    };
    window.addEventListener("scroll", (function() {
        d()
    })), o(), d(), a(), l(), c(), s(n), window.matchMedia("(min-width: 992px)").matches && btyPagination(u, t)
}

function btyMobileFilters(e = document) {
    let t = e.querySelector(".has-product-filters"),
        n = !!t && t.querySelector(".filter-content"),
        i = !!t && t.querySelector(".mobile-filter"),
        r = !!i && i.querySelector(".filter-sort"),
        o = !!i && i.querySelector(".close-button"),
        l = !!i && i.querySelector(".back-button"),
        a = !!i && i.querySelector(".mobile-active-filter"),
        c = !!i && i.querySelector(".mobile-filter-modal"),
        s = !!i && i.querySelector(".mobile-filter-form"),
        u = s ? s.querySelectorAll(".filter-item") : [],
        d = !!s && s.querySelector(".form-footer .active-filter-item"),
        f = !!s && s.querySelector('[type="submit"]');
    if (!(r && o && l && u.length && c && d && f)) return;
    let m = new URL(window.location.href);
    btyMiniSearch(t);
    const y = function() {
            let e = i.querySelectorAll("a.active-filter-item");
            e.length && e.forEach((function(e) {
                e.addEventListener("click", (function(t) {
                    t.preventDefault(), m = new URL(e.href, window.location.origin), p(m)
                }))
            }))
        },
        b = function(e = s) {
            e.querySelectorAll(".filter-item").forEach((function(e) {
                let t = e.querySelector(".filter-heading"),
                    n = e.querySelector(".filter-content");
                t && n && (t.onclick = function() {
                    e.classList.toggle("active")
                })
            }))
        };
    let p = function(e, r = !1) {
            let o = document.querySelector(".loading-bar");
            o && (o.classList.add("active"), o.style.transform = "scaleX(0.7)");
            let l = t.querySelector('[name="q"]');
            if (l && (e.searchParams.set("q", l.value.trim()), e.searchParams.set("type", btyGlobals.search_type), e.searchParams.set("options[prefix]", "last"), e.searchParams.set("options[unavailable_products]", btyGlobals.search_unavailable)), document.documentElement.setAttribute("data-filtering", ""), e) {
                let t = e.toString();
                n && n.classList.contains("infinite-scroll") && ["infinite-scroll", "filters", "sort_by"].includes(r) && (t = btyRemoveParam("page", t)), window.history.pushState({
                    path: t
                }, "", t)
            }
            let s = e && e.search ? "&" + e.search.slice(1) : "",
                u = window.location.pathname + "?section_id=" + t.getAttribute("data-id") + s;
            fetch(u).then((function(e) {
                if (200 !== e.status) throw e;
                return e.text()
            })).then((function(o) {
                let l = t.querySelector(".pagination"),
                    s = t.querySelector(".products"),
                    u = t.querySelectorAll(".results-count"),
                    d = t.querySelector(".infinite-loading");
                if (a && (a.innerHTML = btyGetSectionHtml(o, ".mobile-active-filter")), u.length && u.forEach((function(e) {
                        e.innerHTML = btyGetSectionHtml(o, ".results-count"), n.classList.contains("infinite-scroll") && e.querySelector(".from-count") && (e.querySelector(".from-count").innerText = 1)
                    })), c && (c.innerHTML = btyGetSectionHtml(o, ".mobile-filter-modal")), l && (l.innerHTML = btyGetSectionHtml(o, ".pagination")), n)
                    if (n.classList.contains("infinite-scroll"))
                        if ("infinite-scroll" === r) {
                            let e = function() {
                                let e = t.querySelectorAll(".product-card.ready");
                                if (!e.length) return;
                                const n = new IntersectionObserver((function(e, t) {
                                    e.forEach((function(e) {
                                        if (e.isIntersecting) {
                                            let n = e.target;
                                            n.classList.contains("animate") || n.classList.add("animate"), t.unobserve(n)
                                        }
                                    }))
                                }));
                                e.forEach((function(e) {
                                    n.observe(e)
                                }))
                            };
                            e(), window.addEventListener("scroll", e)
                        } else s.innerHTML = btyGetSectionHtml(o, ".products");
                else s && (s.innerHTML = btyGetSectionHtml(o, ".products"));
                else t.parentNode.classList.contains("search-page-section") && s && (s.innerHTML = btyGetSectionHtml(o, ".products"));
                let f = btyGetSectionHtml(o, ".infinite-loading");
                d ? f ? (d.innerHTML = f, d.classList.remove("visible")) : d.remove() : s && f && s.insertAdjacentHTML("afterend", '<div class="infinite-loading">' + f + "</div>");
                let m = i.querySelector(".mobile-filter-form");
                m && b(m), btyAnimationImageLoad(t), btyRangeSlider(t), y(), btyPagination(p, e), "function" == typeof btyToggleDetails && btyToggleDetails(t), "function" == typeof btyQuickView && btyQuickView(t), "function" == typeof btySwatch && btySwatch(t), "function" == typeof btyQuickAdd && btyQuickAdd(t), "function" == typeof btyAccordionHandle && btyAccordionHandle(t), "function" == typeof btyAddToCart && btyAddToCart(t), document.dispatchEvent(new CustomEvent("product-card-updated"))
            })).catch(console.error).finally((function() {
                document.documentElement.removeAttribute("data-filtering"), "infinite-scroll" !== r && function() {
                    let e = t.querySelector(".mobile-filter");
                    e && e.getBoundingClientRect().top < 0 && e.scrollIntoView({
                        behavior: "smooth"
                    })
                }();
                let e = document.querySelector(".loading-bar");
                e && (e.style.transform = "scaleX(1)", e.setAttribute("data-finished", ""), e.addEventListener("transitionend", (function(t) {
                    "transform" === t.propertyName && "string" == typeof e.getAttribute("data-finished") && (e.classList.remove("active"), e.removeAttribute("data-finished"), e.style.transform = "scaleX(0)")
                })))
            }))
        },
        h = i.querySelector(".form-header .heading"),
        g = h ? h.innerHTML : "";
    i.onclick = function(e) {
        let t = e.target;
        if (r === t) return c.triggerElement = r, i.classList.add("is-open"), document.documentElement.classList.add("filter-open"), o && setTimeout((() => o.focus()), 400), void btyTrapFocus(c, o);
        if (o === t || c === t) return e.preventDefault(), i.classList.remove("is-open"), document.documentElement.classList.remove("filter-open"), void(c.triggerElement && c.triggerElement.focus());
        if (t.classList.contains("filter-heading") && h) {
            let e = t.querySelector(".heading-text");
            e && (e.hasAttribute("data-helptext") ? h.innerHTML = e.innerHTML + '<span class="item-helptext">' + e.getAttribute("data-helptext") + "</span>" : h.innerHTML = e.innerHTML)
        } else {
            if (l === t || d === t) {
                let e = s.querySelector(".filter-item.active");
                return e && e.classList.remove("active"), i.classList.remove("transform"), void(g && (h.innerHTML = g))
            }
            if (f === t) {
                e.preventDefault();
                let t = new FormData(s),
                    n = window.location.pathname + "?" + new URLSearchParams(t).toString();
                return m = new URL(n, window.location.origin), i.classList.remove("is-open"), document.documentElement.classList.remove("filter-open"), void p(m)
            }
        }
    }, b(), y(), window.matchMedia("(max-width: 991px)").matches && btyPagination(p, m)
}
document.addEventListener("DOMContentLoaded", (function() {
    btyToggleNavList(), btyRangeSlider(), btyColumnChange(), btyToggleSidebar(), btyDesktopFilters(), btyMobileFilters()
})), document.addEventListener("shopify:section:select", (function(e) {
    btyToggleNavList(e.target), btyRangeSlider(e.target), btyColumnChange(e.target), btyToggleSidebar(e.target), btyDesktopFilters(e.target), btyMobileFilters(e.target)
}));